export default function SpecTable({ title, columns, rows }) {
  return (
    <div className="mt-8">
      {title && (
        <h4 className="font-display text-lg font-bold text-slate-900 mb-3">{title}</h4>
      )}
      <div className="overflow-x-auto border border-slate-200 rounded-xl">
        <table className="w-full text-left border-collapse">
          <thead className="bg-slate-50">
            <tr>
              {columns.map((c) => (
                <th
                  key={c}
                  className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-slate-700 border-b border-slate-200"
                >
                  {c}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, ri) => (
              <tr
                key={ri}
                className="border-b border-slate-100 last:border-0 hover:bg-slate-50 transition-colors"
              >
                {row.map((cell, ci) => (
                  <td key={ci} className="px-5 py-3 text-sm text-slate-700">
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
